import { Root } from '@radix-ui/react-popover';

export const Popover = Root;
